import React from "react";
import { History } from 'lucide-react';
import { NavItem } from "../NavItem";

export function RemediationReportLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/remediation"
            Icon={History}
            label="Remediation History"
            isCollapsed={isCollapsed}
        />
    );
}